import zh from './zh.json';
import en from './en.json';

export const faultCodesData = {
  zh,
  en
};

export function getFaultCodes(locale = 'zh') {
  return faultCodesData[locale] || zh;
}

export default faultCodesData;